// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1TU0q","content":"styles_content__3qPvK","selectAll":"styles_selectAll__3N9Q9"};